import { render, staticRenderFns } from "./accordion-content.vue?vue&type=template&id=55eb08c3"
import script from "./accordion-content.vue?vue&type=script&lang=js"
export * from "./accordion-content.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports